import type { RouteRecordRaw } from "vue-router";

export const postsRoutes: RouteRecordRaw[] = [
  {
    path: "/posts",
    name: "posts-index",
    component: () => import("./PostListPage.vue"),
    meta: {
      requiresAuth: true,
      title: "posts.index.title",
    },
  },
];
